import { OPERATORS, FIELDS, ARGSOP, SHARE_CLASS } from '../../../../shared/screener-constants';

export const formatShareClassArgs = (fundType, shareClass) => {
  if (shareClass === SHARE_CLASS.ALL) {
    return {
      field: FIELDS.TCFUNDTYPE,
      conditions: [{ operator: OPERATORS.LIKE, values: [fundType] }]
    };
  }
  return {
    field: '',
    conditions: [],
    argsOperator: ARGSOP.AND,
    arguments: [
      {
        field: FIELDS.TCFUNDTYPE,
        conditions: [{ operator: OPERATORS.LIKE, values: [fundType] }]
      },
      {
        field: FIELDS.TCSHARECLASS,
        conditions: [{ operator: OPERATORS.LIKE, values: [shareClass] }]
      }
    ]
  };
};

export const formatFundTypeArgs = args => {
  return {
    field: '',
    conditions: [],
    argsOperator: ARGSOP.OR,
    arguments: args
  };
};

export default formatShareClassArgs;
